import { render, staticRenderFns } from "./InstallationRoutes.vue?vue&type=template&id=6c57e1e4&"
import script from "./InstallationRoutes.vue?vue&type=script&lang=js&"
export * from "./InstallationRoutes.vue?vue&type=script&lang=js&"
import style0 from "./InstallationRoutes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports